/**
 * 认证工具函数（登录 token，非链上 ERC20 授权）
 */

import { getConnection } from "@wagmi/core";
import { wagmiConfig } from "@/config";

const TOKEN_KEY = "token";

export const saveToken = (token: string) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const getToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEY);
};

export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const isAuthenticated = (): boolean => {
  return !!getToken();
};

export type AuthorizationRequirements = {
  requireWallet?: boolean;
  requireToken?: boolean;
};

export type AuthorizationContext = {
  isWalletConnected?: boolean;
  token?: string | null;
};

export type AuthorizationCheckResult =
  | { ok: true }
  | { ok: false; reason: "wallet" | "token" };

export function checkAuthorization(
  requirements: AuthorizationRequirements = {},
  context: AuthorizationContext = {}
): AuthorizationCheckResult {
  const requireWallet = requirements.requireWallet !== false;
  const requireToken = requirements.requireToken !== false;

  const isConnected =
    context.isWalletConnected !== undefined
      ? context.isWalletConnected
      : getConnection(wagmiConfig).isConnected;

  const token = context.token !== undefined ? context.token : getToken();

  if (requireWallet && !isConnected) {
    return { ok: false, reason: "wallet" };
  }
  if (requireToken && !token) {
    return { ok: false, reason: "token" };
  }
  return { ok: true };
}

export function isAuthorized(
  requirements?: AuthorizationRequirements,
  context?: AuthorizationContext
): boolean {
  return checkAuthorization(requirements, context).ok;
}

export const checkLogin = (): boolean => {
  return checkAuthorization({ requireWallet: true, requireToken: true }, {}).ok;
};
